import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCancellation(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={176}
      height={120}
      fill="none"
      {...props}
    >
      <path fill="#232836" d="M0 0h177v121H0z" />
      <g clipPath="url(#cancellation_svg__a)">
        <path fill="#F6F3F1" d="M-822-9854H496v29630H-822z" />
        <rect
          width={1077}
          height={30_909.3}
          x={-701.5}
          y={-9750.5}
          stroke="#9747FF"
          strokeDasharray="10 5"
          rx={4.5}
        />
        <g clipPath="url(#cancellation_svg__b)">
          <path
            fill="#fff"
            d="M-99-23.121c0-17.673 14.327-32 32-32h311c17.673 0 32 14.327 32 32v490c0 17.673-14.327 32-32 32H-67c-17.673 0-32-14.327-32-32z"
          />
          <path
            stroke="#DB646A"
            strokeLinecap="square"
            d="M78.197 43.565v-4.686m20.606 4.686v-4.686M78.197 52.936h20.606m-23.03 26.943h25.454c4.017 0 7.273-3.147 7.273-7.029V50.593c0-3.882-3.256-7.028-7.273-7.028H75.773c-4.017 0-7.273 3.146-7.273 7.028V72.85c0 3.882 3.256 7.029 7.273 7.029Z"
          />
          <mask id="cancellation_svg__d" fill="#fff">
            <path d="M138.5 60.879c0 27.614-22.386 50-50 50-13.807 0-26.307-5.597-35.355-14.645C44.096 87.186 38.5 74.686 38.5 60.88c0-27.614 22.386-50 50-50 13.807 0 26.307 5.596 35.355 14.645 9.049 9.048 14.645 21.548 14.645 35.355" />
          </mask>
          <path
            fill="url(#cancellation_svg__c)"
            d="m120.32 21.988-70.71 70.71 7.07 7.072 70.711-70.71zm8.18 38.89c0 22.092-17.909 40.001-40 40.001v20c33.137 0 60-26.863 60-60zm-80 0c0-22.09 17.909-40 40-40v-20c-33.137 0-60 26.864-60 60zm40-40c11.049 0 21.035 4.467 28.284 11.717l14.142-14.142C120.079 7.606 105.066.878 88.5.878zm28.284 11.717c7.25 7.25 11.716 17.235 11.716 28.284h20c0-16.566-6.727-31.58-17.574-42.426zM88.5 100.879c-11.049 0-21.035-4.466-28.284-11.716l-14.142 14.142c10.846 10.847 25.86 17.574 42.426 17.574zM60.216 89.163C52.966 81.913 48.5 71.927 48.5 60.88h-20c0 16.566 6.727 31.58 17.574 42.426z"
            mask="url(#cancellation_svg__d)"
          />
        </g>
      </g>
      <defs>
        <clipPath id="cancellation_svg__a">
          <path fill="#fff" d="M-822-9854H496v29630H-822z" />
        </clipPath>
        <clipPath id="cancellation_svg__b">
          <path
            fill="#fff"
            d="M-99-23.121c0-17.673 14.327-32 32-32h311c17.673 0 32 14.327 32 32v490c0 17.673-14.327 32-32 32H-67c-17.673 0-32-14.327-32-32z"
          />
        </clipPath>
        <linearGradient
          id="cancellation_svg__c"
          x1={88.5}
          x2={88.07}
          y1={10.879}
          y2={86.412}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#F9E1E1" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCancellation);
export default ForwardRef;
